import MealsSummary from './MealsSummary'
import AvailableMeals from './AvailableMeals'

export default function Meals() {
  return (
    <>
      <MealsSummary />
      <AvailableMeals />
    </>
  )
}
